import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, Maximize } from 'lucide-react';
import './Projects.css';
import useSEO from '../hooks/useSEO';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useSEO({
    title: 'Projelerimiz - Efruz İnşaat | Tamamlanan ve Devam Eden Projeler',
    description: 'Efruz İnşaat\'ın tamamladığı ve devam eden lüks konut, ticari yapı ve özel projeleri keşfedin. Her projede kalite, estetik ve fonksiyonelliği bir araya getiriyoruz.',
    keywords: 'efruz inşaat projeleri, tamamlanan projeler, devam eden projeler, lüks konut projeleri, ticari yapı projeleri, inşaat portföyü'
  });

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || '/public/api';
        const response = await fetch(`${API_BASE}/projects.php`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();
        console.log('Projects API Response:', text.substring(0, 200));
        const result = JSON.parse(text);
        if (result.success) {
          setProjects(result.data || []);
        } else {
          console.error('Failed to fetch projects:', result.error);
          setProjects([]);
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <div className="projects-page">
      {/* Page Title Section */}
      <section className="page-title-section">
        <div className="container">
          <h1 className="page-title">Projelerimiz</h1>
          <p className="page-description">
            Tamamladığımız ve devam eden projelerimizi keşfedin. Her projede kalite, estetik ve fonksiyonelliği bir araya getirerek, müşterilerimizin hayallerini gerçeğe dönüştürüyoruz.
          </p>
        </div>
      </section>

      {/* Filter & Projects */}
      <section className="projects-listing section-padding">
        <div className="container">
          {/* Filter Buttons */}
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              Tüm Projeler
            </button>
            <button 
              className={`filter-btn ${filter === 'completed' ? 'active' : ''}`}
              onClick={() => setFilter('completed')}
            >
              Tamamlanan
            </button>
            <button 
              className={`filter-btn ${filter === 'ongoing' ? 'active' : ''}`}
              onClick={() => setFilter('ongoing')}
            >
              Devam Eden
            </button>
          </div>

          {/* Projects Grid - 4 Column Split */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <p>Yükleniyor...</p>
            </div>
          ) : filteredProjects.length > 0 ? (
            <div className="projects-split-grid">
              {filteredProjects.map((project, index) => (
                <Link 
                  key={project.id} 
                  to={`/projects/${project.id}`} 
                  className="project-split-card"
                  data-index={index}
                >
                  <div className="project-split-image-wrapper">
                    <img src={project.image} alt={project.name} className="project-split-image" />
                    <div className="project-split-title">
                      <h3 className="project-split-name">{project.name}</h3>
                    </div>
                    <div className="project-split-description">
                      <p>{project.description || ''}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <p>Henüz proje eklenmemiş.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;
